import axios, {AxiosResponse} from "axios";
let baseURL = process.env.REACT_APP_BASE_URL;
let token = process.env.REACT_APP_IPX_TOKEN;
const IcarusServices = {
    storedProcedure
}

async function storedProcedure(sp,data){
    const config = {
        headers:{
            'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
            Authorization : 'Bearer ' + localStorage.getItem('appToken'),
        }
    }

    let procedure = baseURL.replace('api/','procedure/' + sp);

    // window.alert(procedure);
    
    return await axios.post(procedure,data,config);
}

export default IcarusServices;